// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"8cd98671","206":"c73bf693","213":"34e0291a","221":"afa3c76e","251":"93f8b54b","305":"deb08fd0","455":"2fe6a096","497":"a141fcec","513":"c26e8ca1","996":"b38b92a8"}[chunkId] + ".chunk.js";
};